import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const wrappedIconFn = /* @__PURE__ */ createRecipe('wrapped-icon', {
  "variant": "filled",
  "shape": "rounded",
  "color": "primary",
  "size": "m"
}, [
  {
    "variant": "filled",
    "color": "primary",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "primary.background.2.enabled"
    }
  },
  {
    "variant": "filled",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.2.onBrand.enabled",
      "backgroundColor": "neutral.background.2.enabled"
    }
  },
  {
    "variant": "outlined",
    "color": "primary",
    "css": {
      "color": "primary.foreground.1.enabled",
      "borderColor": "primary.stroke.2.enabled"
    }
  },
  {
    "variant": "outlined",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.1.enabled",
      "borderColor": "neutral.stroke.3.enabled"
    }
  }
])

const wrappedIconVariantMap = {
  "variant": [
    "unstyled",
    "filled",
    "outlined"
  ],
  "shape": [
    "unstyled",
    "rounded",
    "square"
  ],
  "color": [
    "unstyled",
    "primary",
    "neutral"
  ],
  "size": [
    "l",
    "m",
    "s"
  ]
}

const wrappedIconVariantKeys = Object.keys(wrappedIconVariantMap)

export const wrappedIcon = /* @__PURE__ */ Object.assign(memo(wrappedIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'wrappedIcon',
  __getCompoundVariantCss__: wrappedIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: wrappedIconVariantKeys,
  variantMap: wrappedIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, wrappedIconVariantKeys)
  },
  getVariantProps: wrappedIconFn.getVariantProps,
})